import { Button, ToastProps, Typography, useToast } from "@hellocarbo/lasagne";
import { Copy } from "lucide-react";
import { useTranslation } from "react-i18next";

import { copyToClipboard } from "@/utils/misc";

type CopyToClipboardButtonProps = {
  url: string;
  toastProps?: ToastProps;
};

function CopyToClipboardButton({
  url,
  toastProps,
}: CopyToClipboardButtonProps) {
  const { t } = useTranslation("common");
  const { toast } = useToast();

  const copyUrlToClipboard = async () => {
    await copyToClipboard(url);
    if (toastProps) {
      toast(toastProps);
    }
  };

  return (
    <div className="gap-x-sm border-grayscale-x-light py-2xs pl-xs pr-2xs flex w-fit max-w-full items-center justify-between rounded-md border">
      <div className="max-w-[75%] overflow-hidden text-nowrap text-ellipsis">
        <Typography step="-1">{url}</Typography>
      </div>
      <Button
        className="gap-x-2xs bg-secondary-xx-light! text-secondary! hover:border-secondary! focus:border-secondary! flex items-center rounded-md border border-transparent text-sm font-medium shadow-none! transition-all duration-200 ease-out active:border-transparent! active:duration-150"
        onClick={copyUrlToClipboard}
      >
        <Copy className="size-xs" />
        <span>{t("copy")}</span>
      </Button>
    </div>
  );
}

export default CopyToClipboardButton;
